<template>
  <div class="addBtnBox is--open">
    <div class="addBtnBox_content position-relative">
      <b-link v-for="(page, ind) in orderedList"
              :key="ind"
              v-b-tooltip.hover.right="page.title"
              v-ripple
              class="addBtnBox_subBtn d-flex align-items-center justify-content-center btn btn-primary p-1"
              :class="{ 'is--open': openBtn }"
              :title="page.title"
              :to="page.link"
              v-on="{ click: (page.action) ? page.action : '' }">
        <IconSvg class="addBtnBox_icon icon--sm"
                 :icon="page.icon" />
      </b-link>

      <button v-ripple
              class="addBtnBox_fixedBtn btn btn-primary"
              :class="{ 'icon-animate-open': openBtn }"
              :title="title"
              @click="openBtn = !openBtn">
        <IconSvg class="addBtnBox_icon icon--sm"
                 icon="add" />
      </button>
    </div>

    <b-link v-b-tooltip.hover.left="'Importar imagens em lote'"
            v-ripple
            class="btnImportarLote d-flex justify-content-center align-items-center btn btn-primary p-2"
            placement="bottom"
            @click="toImportarImagens">
      <IconSvg class="addBtnBox_icon icon--sm"
               icon="imagePlusWhite" />
    </b-link>
  </div>
</template>

<script>
  export default {
    name: "AddButton",
    props: {
      title: {
        type: String,
        default: () => ''
      }
    },
    data () {
      return {
        openBtn: false,
        listLinks: [
          {
            link: '',
            title: 'Importar Pré-Registro',
            icon: 'copy',
            type: 'preRegistro',
            action: () => {
              this.$emit('OnShowModal', 'preRegistro')
            }
          },
          {
            // link: { name: 'cadastro_nascimento', params: { idNasc: 'novo' } },
            link: '',
            title: 'Cadastrar Registro de Nascimento',
            icon: 'nascimento',
            type: 'nascimento',
            id: 3,
            action: () => {
              this.$emit('OnShowModal', 'nascimento')
            }
          },
          {
            link: '',
            title: 'Cadastrar Registro de Casamento',
            icon: 'engagement',
            type: 'casamento',
            id: 2,
            action: () => {
              this.$emit('OnShowModal', 'casamento')
            }
          },
          {
            // link: { name: 'cadastro_obito' },
            link: '',
            title: 'Cadastrar Registro de Óbito',
            icon: 'flower',
            type: 'obito',
            id: 1,
            action: () => {
              this.$emit('OnShowModal', 'obito')
            }
          }
        ]
      }
    },
    computed: {
      orderedList: function () {
        return _.orderBy(this.listLinks, ['id'])
      }
    },
    methods: {
      toImportarImagens () {
        this.$router.push('importar-imagens-em-lote')
      }
    }
  }
</script>

<style lang="scss">
  @import '../../scss/_utilities/exports';

  // variavel de contador máximo de 'NTH-OF-TYPE'
  $countMax: 5;

  /* novos códigos para refatoração */
  .addBtnBox {
    height: pxToRem(48);
    position: fixed;
    right: pxToRem(12);
    top: 74vh;
    width: pxToRem(48);

    &_icon {
      fill: $color-light;
    }

    &_content {}

    &_fixedBtn,
    &_subBtn {
      bottom: 0;
      left: 0;
      line-height: 0;
      position: absolute;
      right: 0;
      top: 0;
    }

    &_fixedBtn {
      animation-duration: 0.5s;
      border-radius: 50% !important;
      box-shadow: 0 0 pxToRem(6) $color-gray;
      height: pxToRem(48);
      margin-right: pxToRem(12);
      transition: box-shadow .15s ease-in-out, left .15s ease-in-out, top .15s ease-in-out;
      width: pxToRem(48);

      &:hover {
        box-shadow: 0 0 pxToRem(6) darken($color-gray, 15%);

        .addBtnBox_icon {
          fill: lighten($color-light, 5%);
        }
      }

      &:not(.icon-animate-open) {
        animation-name: animationIconClose;
        transform: rotate(0deg);

        @keyframes animationIconClose {
          from {
            transform: rotate(45deg);
          }

          to {
            transform: rotate(0deg);
          }
        }
      }
    }

    &_subBtn {
      border-radius: 50% !important;
      height: pxToRem(38);
      margin: 0 auto;
      transition: margin-top .15s ease-in-out;
      width: pxToRem(38);

      @for $count from 1 through $countMax {
        @keyframes iconAnimationIcon-#{$count} {
          from { margin-top: 0; }
          to { margin-top: pxToRem( $count * 46); }
        }

        &.is--open {
          &:nth-of-type(#{$count})  {
            animation-name: iconAnimationIcon-#{$count};
            margin-top: pxToRem(-($count * 46));
          }
        }

        $count: $count + 1;
      }
    }

    @media(min-width: pxToRem(920)) {
      @include calc(right, '(100vw - #{pxToRem(872)}) / 2', null);
    }

    @media(min-width: pxToRem(1024)) {
      @include calc(right, '(100vw - #{pxToRem(966)}) / 2', null);
    }

    @media(max-height: pxToRem(880)) {
      @include calc(top, '(75vh)', null);
    }
  }

  .icon-animate-open {
    animation-name: animationIconOpen;
    transform: rotate(45deg);

    @keyframes animationIconOpen {
      from {
        transform: rotate(0deg);
      }

      to {
        transform: rotate(45deg);
      }
    }
  }

  .btnImportarLote {
    border-radius: 50%;
    box-shadow: 0 0 pxToRem(6) $color-gray;
    height: pxToRem(48);
    line-height: 0;
    position: fixed;
    right: pxToRem(12);
    transition: box-shadow .15s linear, left .15s linear, top .15s linear;
    top: 80vh;
    width: pxToRem(48);
    z-index: 80;

    &.btn {
      border-radius: 50%;
    }

    &_icon {
      fill: $color-light;
    }

    &:hover {
      box-shadow: 0 0 pxToRem(6) darken($color-gray, 15%);

      .addBtn_icon {
        fill: lighten($color-light, 5%);
      }
    }

    @media(min-width: pxToRem(920)) {
      @include calc(right, '(100vw - #{pxToRem(872)}) / 2', null);
    }

    @media(min-width: pxToRem(1024)) {
      @include calc(right, '(100vw - #{pxToRem(966)}) / 2', null);
    }

    @media(max-height: pxToRem(880)) {
      @include calc(right, '(100vw - #{pxToRem(853)}) / 2', null);
      @include calc(top, '(75vh)', null);
    }
  }
</style>
